import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { Link } from 'components/navigation/Link/Link';
import RadioButtonRow from 'components/RadioButtonRow';
import { ReactComponent as Info } from 'style/_assets/icons/info.svg';
import './SuggestedCreditCardStyle.scss';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { SUGGESTED_CREDIT_CARDS } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import { SingleModuleLoader } from 'pages/RedesignDashboard/components/LoadingFactorView';
import { SUGGESTED } from 'types/cardsOffersFilters.constants';
import GoToCCMarketplaceButton from 'components/GoToCCMarketplaceButton';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { SEE_ALL } from 'externals/_tracking/types/clickEventTypes.constants';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import OfferCarousel from 'components/Fragments/OfferCarousel/OfferCarousel';
import CarouselWrapper from 'components/Fragments/CarouselWrapper/CarouselWrapper';
import StandardRedesignMarketplaceCreditCardOfferSwitch from 'components/Offers/StandardRedesignMarketplaceCreditCardOfferSwitch/StandardRedesignMarketplaceCreditCardOfferSwitch';

const SeeAll = props => {
  const { className, onClick } = props;
  return (
    <Link
      to={'/offers/creditcard?creditCardType=MORE_CARDS'}
      onClickCallback={onClick}
      className={`${className} link`}
      ariaLabel="See more"
    >
      SEE MORE
    </Link>
  );
};

const ToSeeAllCreditCards = eventHandler => {
  eventHandler(CLICK, {
    'Click Type': SEE_ALL,
    Link: 'See More Credit Cards',
    Vertical: CREDIT_CARD_VERTICAL,
  });
};

const OffersView = props => {
  const {
    offers,
    pagePosition,
    eventHandler,
    isLoadingChangueCategory,
    containerType,
    selectedCategory,
    modulePosition,
  } = props;
  return (
    <>
      <FlexContainer
        className={'flex-column m-hide t-hide suggestedCCViewContainer'}
      >
        <Row type="carousel" className={'padLR0'}>
          {!isLoadingChangueCategory && (
            <OfferCarouselContainer
              offers={offers}
              extraAttributes={{
                'Filter Type': selectedCategory
                  ? `${selectedCategory}`
                  : `${SUGGESTED}`,
              }}
              type={'creditCardRedesignCarousel'}
              templateCustomClass={'margt6'}
              creditCardTemplate={
                StandardRedesignMarketplaceCreditCardOfferSwitch
              }
              containerType={containerType}
              pagePosition={pagePosition}
              eventHandler={eventHandler}
              datatestid={`redesign-carousel-creditcard-desktop`}
              modulePosition={modulePosition}
            />
          )}
        </Row>
      </FlexContainer>
      <FlexContainer className={'d-hide flex-column'}>
        {!isLoadingChangueCategory && (
          <StaticOfferContainer
            offerMetadataList={offers}
            modulePosition={modulePosition}
            creditCardTemplate={
              StandardRedesignMarketplaceCreditCardOfferSwitch
            }
            pagePosition={pagePosition}
            eventHandler={eventHandler}
            containerType={containerType}
            datatestid={`redesign-creditcard-mobile`}
            extraAttributes={{
              'Filter Type': selectedCategory
                ? `${selectedCategory}`
                : `${SUGGESTED}`,
            }}
          />
        )}
      </FlexContainer>
    </>
  );
};

const ShowOffers = props => {
  const {
    loading,
    filteredOffers,
    selectedCategory,
    pagePosition,
    modulePosition,
    eventHandler,
    isLoadingChangueCategory,
    containerType,
  } = props;
  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: pagePosition,
    modulePosition,
    vertical: CREDIT_CARD_VERTICAL,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr, undefined, false);
  if (loading) {
    return <SingleModuleLoader singleModuleClassName={'margb30 marglr4'} />;
  } else {
    if (filteredOffers?.length >= 1) {
      return (
        <>
          {seenModuleTracking}
          <OffersView
            key={selectedCategory}
            selectedCategory={selectedCategory}
            offers={filteredOffers?.slice(0, 4)}
            pagePosition={pagePosition}
            eventHandler={eventHandler}
            isLoadingChangueCategory={isLoadingChangueCategory}
            containerType={containerType}
            modulePosition={modulePosition}
          />
        </>
      );
    } else {
      return <></>;
    }
  }
};

const MenuCard = ({ menu }) => (
  <div className="menu-card" tabIndex={'0'} role="button">
    <span>{menu}</span>
  </div>
);

const SuggestedCreditCardView = props => {
  const {
    highestApprovalOddsOffers,
    offers,
    eventHandler,
    onChangeCategory,
    selectedCategory,
    categoryList,
    isLoadingChangueCategory,
    loading,
    containerType,
    modulePosition,
    config,
  } = props;
  const filteredOffers =
    selectedCategory === SUGGESTED ? offers : highestApprovalOddsOffers;

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: SUGGESTED_CREDIT_CARDS,
    modulePosition: modulePosition,
    vertical: CREDIT_CARD_VERTICAL,
  });

  const handleEnterKeyPress = (event, menu) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      onChangeCategory(menu);
    }
  };

  const seenModuleTracking = useSeenModulePixel(trackingAtr);
  return (
    <FlexContainer className={'flex-column'}>
      {seenModuleTracking}
      <FlexContainer className={'flex-column gap-14 pos-rel'}>
        <FlexContainer className={'justify-between flex-column'}>
          <FlexContainer className={'justify-between margb20 align-baseline'}>
            <Label type="H4Half" typeHeader={'h2'} className="m-hide t-hide">
              Credit cards for your profile
            </Label>
            <Label
              type="H4Half"
              typeHeader={'h2'}
              className="d-hide m-text-12 bold system_neutral_n500_text"
            >
              Credit cards for your profile
            </Label>
            <SeeAll
              className={
                'Body2 padt6 text-12 m-text-12 align-baseline secondary_text_light'
              }
              onClick={() => ToSeeAllCreditCards(eventHandler)}
            />
          </FlexContainer>
          <FlexContainer
            className={
              'padLR0 padB22 overview-suggested-categories flex-column m-hide t-hide'
            }
          >
            <CarouselWrapper className={'padLR0'}>
              <OfferCarousel type="creditCardCategoriesCarousel">
                {categoryList?.length > 0 &&
                  categoryList.map(menu => (
                    <div
                      key={menu}
                      className={`goal-carousel-item ${
                        selectedCategory === menu ? 'active' : ''
                      }`}
                      onClick={() => onChangeCategory(menu)}
                      onKeyDown={e => handleEnterKeyPress(e, menu)}
                      role="group"
                    >
                      <MenuCard menu={menu} />
                    </div>
                  ))}
              </OfferCarousel>
            </CarouselWrapper>
          </FlexContainer>
          <FlexContainer className="padLR0 padB22 overview-suggested-categories d-hide">
            <RadioButtonRow
              datatestid="creditCardCategoriesRadioFilter"
              list={categoryList}
              onChange={onChangeCategory}
              defaultValue={categoryList[0]}
              value={selectedCategory}
              customButtonClassname="margTB0 margR6 margL0"
            />
          </FlexContainer>
          {config?.showDisclaimerInOffers && (
            <Disclaimer showPartnerText className="margB14" />
          )}
          {filteredOffers?.length === 0 && (
            <FlexContainer className="bgBlue025 borderrad4 pad14 margb20">
              <Label className="margr8" type="Body2">
                <Info title="info" aria-label="info-icon" />
              </Label>
              <Label type="Body2 bold">
                You have no offers available in this category at this time.
              </Label>
            </FlexContainer>
          )}
          <ShowOffers
            loading={loading}
            filteredOffers={filteredOffers}
            selectedCategory={selectedCategory}
            pagePosition={SUGGESTED_CREDIT_CARDS}
            modulePosition={modulePosition}
            eventHandler={eventHandler}
            isLoadingChangueCategory={isLoadingChangueCategory}
            containerType={containerType}
          />
        </FlexContainer>
      </FlexContainer>
      {filteredOffers?.length === 0 && (
        <FlexContainer className={'flex-column gap-14'}>
          <FlexContainer className={'justify-between align-baseline'}>
            <Label type="H5" typeHeader={'h5'}>
              Your Other Suggested Credit Card Offers
            </Label>
            <SeeAll
              className={
                'Body2 m-hide text-12 m-text-12 align-baseline secondary_text_light'
              }
              onClick={() => ToSeeAllCreditCards(eventHandler)}
            />
          </FlexContainer>
          <OffersView
            key={'otherSuggested'}
            offers={offers}
            pagePosition={SUGGESTED_CREDIT_CARDS}
            eventHandler={eventHandler}
            isLoadingChangueCategory={isLoadingChangueCategory}
          />
        </FlexContainer>
      )}
      <GoToCCMarketplaceButton moduleName={SUGGESTED_CREDIT_CARDS} />
    </FlexContainer>
  );
};

export default SuggestedCreditCardView;
